import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const CohotHistory = lazy(() => import("../pages/hcp-profile-cohotHistory"));
const HCP_Profile = lazy(() => import("../pages/hcp-profile"));
const HCP_ProfileDetails = lazy(() => import("../pages/hcp-profile-details"));
const HCP_ProfileListing = lazy(() => import("../pages/hcp-profile-listing"));
const HCPProfileListWithType = lazy(() =>
  import("../pages/hcp-profile-listing-with-type")
);
const AllPersonaListing = lazy(() => import("../pages/all-persona-listing"));
const AllPersonaDetails = lazy(() => import("../pages/all-persona-details"));
const HcpMetaProfile = lazy(() => import("../pages/hcp-meta-profile"));
const HcpDashboard = lazy(() => import("../pages/hcp-dashboard"));

export const HCP_ProfileRouter = [
  {
    path: "hcp-profile",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HCP_ProfileListing />
          </Suspense>
        ),
      },
      {
        path: "all/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HCPProfileListWithType />
          </Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HCP_Profile />
          </Suspense>
        ),
      },
      {
        path: "details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HCP_ProfileDetails />
          </Suspense>
        ),
      },
      {
        path: "cohothistory",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CohotHistory />
          </Suspense>
        ),
      },
      {
        path: "meta-profile/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HcpMetaProfile />
          </Suspense>
        ),
      },
      {
        path: "all-persona-listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllPersonaListing />
          </Suspense>
        ),
      },
      {
        path: "all-persona-details/:name",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllPersonaDetails />
          </Suspense>
        ),
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <HcpDashboard />
          </Suspense>
        ),
      },
    ],
  },
];
